import NumberFormat from 'react-number-format';
import React, { FC } from 'react';
import { FormGroup, Label, DivSuffix } from '../styles';
import clsx from 'clsx';

type TProps = {
  defaultValue: number;
  onChange: (value: number) => void;
  value?: number;
  error?: boolean;
  minValue?: number;
  minNegativeValue?: number;
  maxValue?: number;
  title?: string;
  placeholder?: string;
  suffix?: string;
  prefix?: string;
  decimalScale?: number;
  allowNegative?: boolean;
  className?: string;
  onBlur?: () => void;
};

const FnNumberFormat: FC<TProps> = ({
  defaultValue,
  onChange,
  value = null,
  error = false,
  title = '',
  placeholder = '',
  minValue = 0,
  minNegativeValue = -Number.MAX_SAFE_INTEGER,
  maxValue = Number.MAX_SAFE_INTEGER,
  suffix = '',
  prefix = '',
  decimalScale = 0,
  allowNegative = false,
  className = '',
  onBlur = () => null
}) => (
  <FormGroup className={clsx({ ['is-error']: error }, className)}>
    {title && <Label>{title}</Label>}
    <div>
      {prefix && <DivSuffix className={clsx({ ['prefix']: true })}>{prefix}</DivSuffix>}
      <NumberFormat
        value={value}
        error={!!error}
        className="number-format"
        defaultValue={defaultValue}
        placeholder={placeholder}
        allowLeadingZeros={false}
        allowNegative={allowNegative}
        decimalScale={decimalScale}
        isAllowed={(values) => {
          const { floatValue, formattedValue } = values;
          return (
            formattedValue === '' ||
            (formattedValue === '-' && allowNegative) ||
            (allowNegative
              ? floatValue <= maxValue && floatValue >= minNegativeValue
              : floatValue <= maxValue && floatValue >= minValue)
          );
        }}
        onValueChange={({ floatValue }) => onChange(floatValue)}
        onBlur={onBlur}
      />
      {suffix && <DivSuffix>{suffix}</DivSuffix>}
    </div>
  </FormGroup>
);

export default FnNumberFormat;
